import BaseAPI from "./BaseAPI";
import { AdminOverrideError } from "../Errors.js";
import { userClockEventRoute } from "../routes";

export default class UserClockEventAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, userClockEventRoute, "user-clock-event");
    }

    async Create(data) {
        if (!data.user_id || data.user_id == import.meta.env.VITE_ADMIN_ID) {
            throw AdminOverrideError;
        }
        const result = await this._request("post", this._url(), data);
        this._emit("add", result.id);
        return result;
    }

    async CreateWithOverride(data) {
        if (!data.user_id || data.user_id == import.meta.env.VITE_ADMIN_ID) {
            throw AdminOverrideError;
        }
        const result = await this._request("post", this._url("?override=true"), data);
        this._emit("add", result.id);
        return result;
    }
}
